import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { BusinessDetailsForm } from 'components/BusinessDetails';
import {
  GoogleAutocompleteResultsList,
  GoogleAutocompleteResultsWrapper,
  GoogleAutocompleteImage,
} from 'components/GoogleAutocomplete';
import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import useChangePage from 'hooks/useChangePage';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import { TRIAL_URL } from 'routes/constants';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

import useTrialProtectedPageGuard from '../../hooks/useTrialProtectedPageGuard';
import { FakeWrapper } from '../../layout';
import { Subheading } from '../../styles';

const BusinessInfo = () => {
  const { validateBusinessName } = useBusinessInfoContext() || {};
  const changePage = useChangePage();
  const trackEvent = useTrackAmplitudeEvent('trials.businessInfo.visited');

  useTrialProtectedPageGuard({
    shouldHaveValidLogin: true,
    shouldHaveVerifiedAccount: true,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
    const isValid = validateBusinessName(true);
    trackEvent('trials.businessInfo.nextClicked');

    if (isValid) changePage(`${TRIAL_URL}/loading`, true);
    setIsSubmitting(false);
  };

  return (
    <FakeWrapper
      handleButtonClick={handleSubmit}
      showIcon={true}
      title="What’s the name of your business?"
      ctaId="business-name-continue-btn"
    >
      <Subheading>
        Add your business name so your customers know who they'll be working
        with.
      </Subheading>

      <BusinessWrapper>
        <BusinessDetailsForm
          displayManualLink={false}
          isSubmitting={isSubmitting}
          showFullForm={false}
          size="lg"
        />
      </BusinessWrapper>
    </FakeWrapper>
  );
};

export default BusinessInfo;

const BusinessWrapper = styled.div`
  ${GoogleAutocompleteResultsList} {
    max-height: 190px;
    overflow: auto;
  }

  ${GoogleAutocompleteResultsWrapper} {
    width: 464px;
    left: 23px;
    border-radius: 12px;
    box-shadow: 0 0 0 0.5px rgba(18, 21, 26, 0.08),
      0 4px 8px rgba(18, 21, 26, 0.04), 0 8px 16px -2px rgba(18, 21, 26, 0.04),
      0 16px 32px -4px rgba(18, 21, 26, 0.04);
  }

  ${GoogleAutocompleteImage} {
    height: 14px;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    ${GoogleAutocompleteResultsWrapper} {
      width: 89%;
    }
  }
`;
